import array from './modules/array'
import axios from './modules/axios'
import cast from './modules/cast'
import date from './modules/date'
import debug from './modules/debug'
import image from './modules/image'
import sleep from './modules/sleep'
import string from './modules/string'

/**
 * ユーティリティ
 */
export default {
  array,
  axios,
  cast,
  debug,
  image,
  date,
  sleep,
  string
}
